import { Service } from '@/api/http-service';
import type { CompleteNpsSurveyDto, NpsSurveyCompletionScreenDto } from '@carvia/ros-client-types';

class NpsSurveysService extends Service {
  constructor() {
    super('/nps-surveys');
  }

  async getNpsSurvey(
    id: string,
    secretCompletionToken: string,
  ): Promise<NpsSurveyCompletionScreenDto> {
    const res = await this.httpClient.get<NpsSurveyCompletionScreenDto>(
      `${this.endpoint}/${id}/completion-screen`,
      {
        params: { secretCompletionToken },
      },
    );
    return res.data;
  }

  async complete(
    id: string,
    secretCompletionToken: string,
    survey: CompleteNpsSurveyDto,
  ): Promise<void> {
    await this.httpClient.post(`${this.endpoint}/${id}/complete`, survey, {
      params: { secretCompletionToken },
    });
  }
}

export const npsSurveysService = new NpsSurveysService();
